import { useSciDomain } from 'components';

import { LoaderRenderer } from './LoaderRenderer';

export const Loader = () => {
  const { data: { loader: loaderImg } = {} } = useSciDomain();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-screen tw-min-h-screen tw-bg-layout">
      <LoaderRenderer loaderUrl={loaderImg} />
    </div>
  );
};
